import { useTranslation } from '@/clientWeb/i18n/LanguageContext'

/**
 * Shown instead of the app when a site that is not on TRUSTED_EMBED_ORIGINS
 * frames us. Nothing else renders — no prejoin, no camera prompt, no requests.
 */
export default function EmbedBlockedNotice() {
  const t = useTranslation()
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-xl font-semibold text-foreground">{t('embedMode.notAllowedTitle')}</h1>
        <p className="text-sm text-muted-foreground">{t('embedMode.notAllowedBody')}</p>
      </div>
    </div>
  )
}
